module.exports = __webpack_public_path__ + "static/img/8a.22f0f07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8a.jpg
// module id = 89L5
// module chunks = 0